const fr = {
  layout: {
    cos_button: {
      phone: 'Téléphone',
      update_phone_number_message: 'Le numéro de téléphone a été mis à jour avec succès!'
    },
    time: {
      days: 'Jours',
      hours: 'H',
      mins: 'Min',
      secs: 'S',
      starts: 'Commence',
      starts_immediately: 'Commence maintenant'
    },
    field: {
      host: 'Présentateur'
    },
    copy: 'Copie'
  },
  validations: {
    email: 'ça doit être un courriel valide',
    phone: "n'est pas valide",
    required_field: "c'est un champ obligatoire"
  },
  mailer: {
    need_help: "Besoin d'aide?",
    stop_reminders: 'Ne plus recevoir de notifications',
    cancel_registration: "Annuler l'inscription",
    report_abuse: 'Signaler un abus'
  },
  datetime: {
    no_sessions: 'Aucune session disponible',
    empty_label: 'Date/Heure'
  },
  errors: {
    verification_failed: 'Échec de la vérification. Veuillez réessayer.',
    session_unavailable:
      "L'horaire que vous avez sélectionné n'est plus disponible. Veuillez choisir un autre créneau.",
    challenge_email_mismatch:
      "Veuillez vous inscrire avec la même adresse e-mail que celle utilisée pour vous inscrire à l'événement."
  }
}

export default fr
